export default "__VITE_ASSET__DSc$wiOa__"